export default "__VITE_ASSET__BGPgpWVA__"